"use strict";
var hasOwn = require("../internals/has-own-property");
var defineBuiltIn = require("../internals/define-built-in");
var dateToPrimitive = require("../internals/date-to-primitive");
var wellKnownSymbol = require("../internals/well-known-symbol");
var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
var DatePrototype = Date.prototype;
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}
